import { render, staticRenderFns } from "./TotalRevenueFormDialog.vue?vue&type=template&id=11ad07a4&scoped=true"
import script from "./TotalRevenueFormDialog.vue?vue&type=script&lang=js"
export * from "./TotalRevenueFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TotalRevenueFormDialog.vue?vue&type=style&index=0&id=11ad07a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad07a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ad07a4')) {
      api.createRecord('11ad07a4', component.options)
    } else {
      api.reload('11ad07a4', component.options)
    }
    module.hot.accept("./TotalRevenueFormDialog.vue?vue&type=template&id=11ad07a4&scoped=true", function () {
      api.rerender('11ad07a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/TotalRevenueFormDialog.vue"
export default component.exports